export const styles = {
  container: {
    borderRight: '1px solid #F3F4F9',
    paddingRight: '12px',
    height: '50px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    width: '115px',
    maxWidth: '115px',
    display: 'flex',
    justifyContent: 'space-between',
    textTransform: 'none',
    color: 'black',
    border: 'unset',
    padding: '6px 8px',
    minWidth: 'auto',

    '&:hover': {
      border: 'none',
    },
  },
  popover: {
    '& .MuiPopover-paper': {
      width: '185px',
      marginTop: '8px',
      background: '#FFFFFF',
      border: '1px solid #F3F4F9',
      boxShadow: '0px 4px 10px rgba(35, 37, 47, 0.1), 1px 2px 2px rgba(35, 37, 47, 0.04)',
      borderRadius: '12px',
      padding: '2px',
    },
  },
  navigationItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '12px',
    padding: '14px',

    fontFamily: 'Inter',
    fontSize: '14px',
    color: '#424550',
    textTransform: 'capitalize',
    textDecoration: 'none',
    borderRadius: '8px',

    cursor: 'pointer',
    transition: '300ms',

    '&.active': {
      color: '#4D6EF5',
    },

    '&:hover': {
      background: '#F2F5FF',
    },
  },
};
